import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
	hashbang: false,
	linkActiveClass: 'active',
	mode: 'history',
	base: __dirname,
	routes
})

router.beforeEach((to, from, next) => {
	if (to.path === 'welcome') {
		next()
	}

	if (to.meta.auth && !store.state.token) {
		if (to.path !== '' && to.path !== '/login') {
			sessionStorage.setItem('Shiseido-path', to.path)
		}
		next({ path: '/login' })
	} else {
		next()
	}
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js